export const GLAS = [
  {
    vraag: 'Is de FTU in goede conditie?',
    ja: 'Monteer de juiste NT vergeet niet het stofkapje te verwijderen.',
    nee: 'Hang je lichtpen op en controleer op glasvezel breuk.',
    answerq: true,
    id: 1,
  },
  {
    vraag: 'Komt de NT netjes online?',
    answerq: true,
    ja: 'Controleer of je REF-nummer netjes opkomt in je monteurs tool.',
    nee: 'Hang lichtpen op en controleer of licht aankomt in POP indien toegang.',
    id: 2,
  },
  {
    vraag: 'Is de patch gezet?',
    answerq: true,
    ja: 'Controleer of licht binnen komt op juiste ODF poort',
    nee: 'Zet patch volgens HIO gegevens.',
    id: 3,
  },
  {
    vraag: 'Komt de service ID online in de monteurs tool?',
    answerq: true,
    ja: 'Sluit de modem aan of hang test label kaartje aan verbinding',
    nee: 'Hang je lichtpen op en controleer in de POP op een kruising',
    id: 4,
  },
];
